<template>
  <q-btn
    round
    :dense="dense"
    class="--shadow__bottom"
    @click.stop.prevent="toggleSaveVehicle"
    @mousedown.stop="() => {}"
    @mouseup.stop="() => {}"
    no-caps
  >
    <q-icon
      name="sym_r_star"
      size="26px"
      :class="{ '--icon-filled': isVehicleSaved }"
      :color="isVehicleSaved ? 'amber-6' : undefined"
    />
    <q-tooltip
      anchor="center left"
      self="center right"
      max-width="300px"
      :offset="[6, 6]"
      persistent
    >
      {{ isVehicleSaved ? "Remove From Watchlist" : "Add to Watchlist" }}
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: "VehicleWatchlistButton",
  props: {
    productId: {
      type: String,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVehicleSaved: false
    };
  },
  mounted() {
    this.checkSavedState();
    window.addEventListener("watchlist-updated", this.checkSavedState);
  },
  beforeUnmount() {
    window.removeEventListener("watchlist-updated", this.checkSavedState);
  },
  methods: {
    toggleSaveVehicle() {
      let existingSavedVehicles = window.localStorage.getItem(
        "jfpc-saved-vehicle-product-ids"
      )
        ? JSON.parse(
            window.localStorage.getItem("jfpc-saved-vehicle-product-ids")
          )
        : [];

      if (this.isVehicleSaved) {
        // Remove from saved vehicles
        let savedVehicleIndex = existingSavedVehicles.indexOf(this.productId);

        if (savedVehicleIndex !== -1) {
          existingSavedVehicles.splice(savedVehicleIndex, 1);
        }
      } else {
        // Add to saved vehicles
        if (existingSavedVehicles.indexOf(this.productId) === -1) {
          if (existingSavedVehicles.length >= 250) {
            existingSavedVehicles = existingSavedVehicles.slice(0, 249);
          }
          existingSavedVehicles.unshift(this.productId);
        }
      }

      window.localStorage.setItem(
        "jfpc-saved-vehicle-product-ids",
        JSON.stringify(existingSavedVehicles)
      );
      this.isVehicleSaved = !this.isVehicleSaved;

      // Notify other VehicleWatchlistButton instances
      window.dispatchEvent(new CustomEvent("watchlist-updated"));
    },
    checkSavedState() {
      this.isVehicleSaved = window.localStorage.getItem(
        "jfpc-saved-vehicle-product-ids"
      )
        ? JSON.parse(
            window.localStorage.getItem("jfpc-saved-vehicle-product-ids")
          ).indexOf(this.productId) !== -1
        : false;
    }
  }
};
</script>
